<template>
  <el-badge :value="displayCount" :hidden="displayCount === 0" :type="badgeType">
    <slot />
  </el-badge>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from 'vue'
import { useWorkItemStore } from '@/stores/workItemStore'

const workItemStore = useWorkItemStore()
let timer = null

onMounted(() => {
  workItemStore.fetchCounts()
  // 5분 간격 자동 새로고침
  timer = setInterval(() => workItemStore.fetchCounts(), 5 * 60 * 1000)
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
})

const displayCount = computed(() => workItemStore.counts.total || 0)
const badgeType = computed(() => workItemStore.hasOverdue ? 'danger' : 'info')
</script>
